module.exports = __webpack_public_path__ + "static/img/saaszizhanghao_tubiao.cb8aee3e.png";